import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 1,
  style: {"background-color":"#fff !important","border-radius":"6px"},
  class: "pa-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_layout, {
        wrap: "",
        "ml-3": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn_back, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
          })
        ]),
        _: 1
      }),
      (_ctx.mail)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "default_card large",
            elevation: "0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.mail.subject), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.mail.from), 1),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.mail.date)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_subtitle, { class: "pt-1" }, {
                default: _withCtx(() => [
                  _createTextVNode("A " + _toDisplayString(_ctx.mail.to), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  (_ctx.mail.textAsHtml)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        innerHTML: _ctx.mail.textAsHtml,
                        style: {"background-color":"#fff !important","border-radius":"6px"},
                        class: "pa-6"
                      }, null, 8, _hoisted_1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.mail.text), 1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}